import React from 'react';
import { useSelector } from "react-redux";
import {
  CRow,
  CCol,
  CLabel,
  CInput,
  CSelect,
} from "@coreui/react";

const Bank = (props) => {
  const { bankList, handleInputChange } = props;
  const { insert } = useSelector((state) => state);

  return (
    <>
      <CRow>
        <CCol xs="12" md="6" className="text-left mb-2">
          <CLabel>
            <span>*</span>은행
          </CLabel>
          <CSelect
            custom
            name="bankCd"
            id="bankCd"
            value={insert.reqTaskInfo.bankCd || ""}
            onChange={handleInputChange}
            disabled={
              insert.reqTaskInfo.stCd === "10" ||
              insert.reqTaskInfo.stCd === "99"
                ? false
                : true
            }
          >
            <option value="">선택</option>
            {bankList.map((bank) => (
              <option key={bank.DTL_CD} value={bank.DTL_CD}>
                {bank.CD_NM}
              </option>
            ))}
          </CSelect>
        </CCol>
        <CCol xs="12" md="6" className="text-left mb-2">
          <CLabel>
            <span>*</span>계좌번호
          </CLabel>
          <CInput
            type="text"
            id="actNo"
            name="actNo"
            placeholder="숫자만입력"
            value={insert.reqTaskInfo.actNo || ""}
            maxLength="20"
            onChange={handleInputChange}
            disabled={
              insert.reqTaskInfo.stCd === "10" ||
              insert.reqTaskInfo.stCd === "99"
                ? false
                : true
            }
          />
        </CCol>
      </CRow>
      <CRow>
        <CCol xs="12" className="text-left mb-2">
          <CLabel>
            <span>*</span>예금주&nbsp;&nbsp;
            <small>본인명의의 계좌만 가능합니다.</small>
          </CLabel>
          <CInput
            type="text"
            id="actNm"
            name="actNm"
            defaultValue={insert.reqTaskInfo.actNm || ""}
            disabled
          />
        </CCol>
      </CRow>
    </>
  )
}

export default React.memo(Bank);